import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import TopNav from 'components/TopNav/TopNav';
import store from 'store';
import { setTheme } from 'store/slices/theme-slice';
import { getSignupStatus } from 'utils/signup-status';
import {
  decodeToken,
  getTokenStatus,
  loadTokenFromStorage,
  setToken,
} from 'utils/token';

export const Route = createFileRoute('/auth')({
  component: PublicLayout,
  beforeLoad: async () => {
    store.dispatch(setTheme('light'));

    const token = loadTokenFromStorage();
    const tokenStatus = getTokenStatus(decodeToken(token));

    if (tokenStatus.status == 'needs-2fa') {
      setToken(token!);
      const tfaRoute = '/auth/login/2fa';
      if (
        location.pathname != tfaRoute &&
        location.pathname != '/auth/reset-two-factor' &&
        location.pathname != '/auth/reset-two-factor/submitted'
      ) {
        throw redirect({
          to: tfaRoute,
        });
      }
    }

    if (tokenStatus.status == 'authenticated') {
      setToken(token!);
      const { active, defaultSignupPage, allowedSignupPages } =
        await getSignupStatus();
      if (active) {
        throw redirect({
          to: '/products',
        });
      } else if (!allowedSignupPages?.includes(location.pathname)) {
        throw redirect({
          to: defaultSignupPage!,
        });
      }
    }
  },
});

function PublicLayout() {
  return (
    <TopNav>
      <Outlet />
    </TopNav>
  );
}
